import React, { FC } from 'react';
import { Image } from '../Image';
import styles from './EsgReportCard.module.scss';

interface Props {
  EsgreportCardData: { [key: string]: string };
}
const EsgReportCard: FC<Props> = (props) => {
  const { EsgreportCardData } = props;
  const { coverImg, title, date, downBtnURL } = EsgreportCardData;
  return (
    <>
      <div className={styles['Report-card-box']}>
        <a href={downBtnURL} target="_blank" rel="noreferrer">
          <div className={styles['report-img-wrap']}>
            <Image src={coverImg} width={500} height={679} layout="responsive" />
          </div>
          <div className={styles['report-info-box']}>
            <div className={styles['report-title']}>{title}</div>
            <p className={styles['report-date']}>{date}</p>
          </div>
        </a>
      </div>
    </>
  );
};

EsgReportCard.displayName = 'EsgReportCard';
export default EsgReportCard;
